var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#1a92d0",
    d: "M21.224 9.11H3.249l6.883-6.556a.901.901 0 1 0-1.243-1.306L1.028 8.736a1.803 1.803 0 0 0 .016 2.564l7.845 7.472a.897.897 0 0 0 1.274-.03.9.9 0 0 0-.03-1.274L3.22 10.912h18.004a.901.901 0 0 0 0-1.802z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#1a90ce",
    strokeMiterlimit: 20,
    d: "M21.224 9.11v0H3.249v0l6.883-6.556a.901.901 0 1 0-1.243-1.306L1.028 8.736a1.803 1.803 0 0 0 .016 2.564l7.845 7.472a.897.897 0 0 0 1.274-.03.9.9 0 0 0-.03-1.274L3.22 10.912v0h18.004a.901.901 0 0 0 0-1.802z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLeftArrow);
export default __webpack_public_path__ + "static/media/icon-left-arrow.6895014f994fb0e4316f299782662964.svg";
export { ForwardRef as ReactComponent };